import { Dropdown } from 'components/filters/Dropdown';
import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';
import { getTotalCountFromHeader, isDateValid, isFunction, isNumberOrStringValid, isStringTrimNotEmpty } from 'functions';
import { useCustomSelector } from 'hooks';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useMonthlyReportColumns } from '../hooks/useMonthlyReportColumns';

export default function MonthlyReport({ 
    queries,
    isMonthlyReportVisible,
    setIsMonthlyReportVisible: setIsMonthlyReportVisible_props,
    selectedSalesPersonMonthly, selectedDate,
    setSelectedDate: setSelectedDate_props,
}) {
    let setIsMonthlyReportVisible = isFunction(setIsMonthlyReportVisible_props)? setIsMonthlyReportVisible_props:() => {};
    let setSelectedDate = isFunction(setSelectedDate_props)? setSelectedDate_props:() => {};

    const [commissionType, setCommissionType] = useState("invoiceLevel1");

    const {
        getInvoiceCommissionDrillDownList_requesting, invoiceCommissionDrillDownList,
        invoiceCommissionDrillDownListHeader,

        getCreditNoteCommissionDrillDownList_requesting, creditNoteCommissionDrillDownList,
        creditNoteCommissionDrillDownListHeader
    } = useCustomSelector("reporting");

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const {
        getInvoiceCommissionDrillDownList, getCreditNoteCommissionDrillDownList
    } = useReporting();

    const columns = useMonthlyReportColumns(commissionType);

    let data = [];
    let headers = {};
    let getDataFunc = () => {};
    if (isDateValid(selectedDate)) {
        switch (commissionType) {
            case "invoiceLevel1":
                data = invoiceCommissionDrillDownList;
                headers = invoiceCommissionDrillDownListHeader;
                getDataFunc = (currentPage, pageSize) => {
                    getInvoiceCommissionDrillDownList(currentPage, pageSize, undefined, queries.current);
                };
                break;
            case "invoiceLevel2":
                data = invoiceCommissionDrillDownList;
                headers = invoiceCommissionDrillDownListHeader;
                getDataFunc = (currentPage, pageSize) => {
                    getInvoiceCommissionDrillDownList(currentPage, pageSize, undefined, {
                        ...queries.current,
                        level1: false
                    });
                };
                break;
            case "creditNoteLevel1":
                data = creditNoteCommissionDrillDownList;
                headers = creditNoteCommissionDrillDownListHeader;
                getDataFunc = (currentPage, pageSize) => {
                    getCreditNoteCommissionDrillDownList(currentPage, pageSize, undefined, queries.current);
                };
                break;
            case "creditNoteLevel2":
                data = creditNoteCommissionDrillDownList;
                headers = creditNoteCommissionDrillDownListHeader;
                getDataFunc = (currentPage, pageSize) => {
                    getCreditNoteCommissionDrillDownList(currentPage, pageSize, undefined, {
                        ...queries.current,
                        level1: false
                    });
                };
                break;
        }
    }

    useEffect(() => {
        getDataFunc();
    }, [commissionType])

    return (
        <DashboardLayout
            headerTitle={selectedSalesPersonMonthly}

            bodyClassName={"invoice-commission-drill-down"}
            body={(
                <GeneralTable
                    className={"invoice-commission-drill-down__table"}
                    columns={columns}
                    data={userPermissions?.Internal_SalesPersonReport_View? data: []}
                    
                    getTableData={getDataFunc}
                    
                    outerTableHeader={() => {
                        return (
                            <div className={"table__header "}>
                                <div className={"header__title tableHeaderTitle "}>
                                    {moment(selectedDate).format("MMMM YYYY")}
                                </div>
                            </div>
                        );
                    }}

                    bottomOuterTableHeader={() => {
                        return (
                            <div className={"table__table-filter d-flex flex-wrap align-items-center"}>
                                <Dropdown
                                    className={"bottom-section__company-id"}

                                    selectedValueClassName={"company-id__input"}

                                    options={[
                                        {
                                            label: "Invoice (New Outlet)",
                                            value: "invoiceLevel1"
                                        },
                                        {
                                            label: "Invoice (Recursive)",
                                            value: "invoiceLevel2"
                                        },
                                        {
                                            label: "Credit Note (New Outlet)",
                                            value: "creditNoteLevel1"
                                        },
                                        {
                                            label: "Credit Note (Recursive)",
                                            value: "creditNoteLevel2"
                                        },
                                    ]}
                                    valueFromParent={commissionType}
                                    selectedValue_default={commissionType}
                                    onChange={(value) => {
                                        setCommissionType(value);
                                    }}
                                />
                            </div>
                        );
                    }}

                    isTableDataLoading={getInvoiceCommissionDrillDownList_requesting || getCreditNoteCommissionDrillDownList_requesting}
                    isTableRefreshRequired={isMonthlyReportVisible}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(headers)}

                    isColumnResizeable
                    isTableOddRowsDarken
                />
            )}

            isHeaderCloseIconVisible
            onClose={() => {
                setSelectedDate(undefined);
                setCommissionType("invoiceLevel1");
            }}
            updateParentState_visiblity={setIsMonthlyReportVisible}
        />
    );
}